import { ALLOWED_RE, NAME_ERROR_CODES, NAME_MAX_LEN } from './constants';

export const normalizeName = (value) => {
  if (value == null) {
    return '';
  }
  return String(value).trim();
};

export const validateNickname = (value) => {
  if (value == null) {
    return '';
  }

  if (value === '') {
    return '';
  }

  const normalized = normalizeName(value);

  if (normalized.length === 0) {
    return NAME_ERROR_CODES.ONLY_SPACES;
  }

  if (normalized.length > NAME_MAX_LEN) {
    return NAME_ERROR_CODES.TOO_LONG;
  }

  if (!ALLOWED_RE.test(normalized)) {
    return NAME_ERROR_CODES.INVALID_CHARS;
  }

  return '';
};

export const getNicknameInputError = (nextValue) => {
  if (nextValue == null) {
    return '';
  }

  const raw = String(nextValue);

  if (raw.length > NAME_MAX_LEN) {
    return NAME_ERROR_CODES.TOO_LONG;
  }

  if (!ALLOWED_RE.test(raw)) {
    return NAME_ERROR_CODES.INVALID_CHARS;
  }

  return '';
};
